import React from 'react';
import { AtSignIcon, FacebookIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'tuconexioneducativa@gmail.com',
  href: 'mailto:tuconexioneducativa@gmail.com'
}, {
  icon: AtSignIcon,
  label: 'Instagram: @Tuconexioneducativa',
  href: 'https://instagram.com/tuconexioneducativa'
}, {
  icon: FacebookIcon,
  label: 'Facebook: Tuconexioneducativa',
  href: 'https://facebook.com/tuconexioneducativa'
}];
export function Footer() {
  return <footer className="bg-night pb-28 lg:pb-14" data-id="element-80" data-mp="37o6cv1anxdd">
      <div className="mx-auto max-w-content px-6 pt-14" style={{
      paddingTop: "26px"
    }} data-id="element-81" data-mp="36d3cxfoatnb">
        <p className="mx-auto max-w-lg text-center font-display text-2xl leading-snug text-gold-soft" data-id="element-82" data-mp="3lggc8tyy53f3">
          “Tu palabra es una lámpara para mis pasos y una luz en mi camino.” — Sal 119,105
        </p>

        <div className="mt-10 flex flex-col items-center gap-6 border-t border-night-line pt-8 md:flex-row md:justify-between" data-id="element-83" data-mp="2a19qzer4jatl">
          <ul className="flex flex-col items-center gap-3 font-sans text-sm md:flex-row md:gap-8" data-id="element-84" data-mp="3l9ahbtogro9p">
            {links.map(link => <li key={link.label} data-id="element-85" data-mp="3gb8s0r0g2sps">
                <a href={link.href} className="inline-flex items-center gap-2 text-parchment/70 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-86" data-mp="3gca674crbvbq">
                  <link.icon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="3q8dhazpl74at" />
                  {link.label}
                </a>
              </li>)}
          </ul>

          <p className="text-center font-sans text-xs leading-relaxed text-parchment/45 md:text-right" data-id="element-88" data-mp="80nrednpyga8">
            © GPS Bíblico™ 2026 — Todos los derechos reservados.
            <br data-id="element-89" data-mp="hsacd1puztq6" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}